export const LEAGUE_CONFIGS = {
  epl: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  ligue1: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  bet365: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  ncaaf: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  default: {
    playerHeadshot: (externalRef) =>
      `https://assets.nhle.com/mugs/nhl/latest/${externalRef}.png`,
    teamLogo: (logoRef) =>
      `https://assets.nhle.com/logos/nhl/svg/${logoRef}_light.svg`,
    playerFileName: (externalRef) => `${externalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
};
const SCORING_BREAKDOWN_CONFIG_BY_SPORT = {
  hockey: [
    "goal",
    "assist",
    "shotOnTarget",
    "hockeyHit",
    "hockeyBlockedShot",
    "teamWin",
    "hockeyTeamPowerPlayGoal",
    "hockeyTeamShortHandedGoal",
    "teamGoalAgainst",
    "teamCleanSheet",
    "teamSave",
  ],
  soccer: [
    "goal",
    "assist",
    "shotOnTarget",
    "tackleWon",
    "cleanSheet",
    "passIntercepted",
    "teamWin",
    "teamGoalAgainst",
    "teamCleanSheet",
    "teamSave",
    "teamCorner",
    "matchPlayed",
  ],
  australian_football: [
    "australianFootballKicks",
    "australianFootballHandballs",
    "australianFootballTackles",
    "australianFootballHitouts",
    "australianFootballGoals",
    "australianFootballFreeKicksAgainst",
    "australianFootballTeamWin",
    "australianFootballTeamGoals",
    "australianFootballTeamTackles",
    "australianFootballTeamMarks",
    "australianFootballTeamDefensiveLockdown",
  ],
  rugby: [
    "rugbyTries",
    "rugbyTryAssists",
    "rugbyLineBreaks",
    "rugbyTackles",
    "rugbyGoals",
    "rugbyTackleBreaks",
    "rugbyTeamWin",
    "rugbyTeamTries",
    "rugbyTeamTackles",
    "rugbyTeamLineBreaks",
    "rugbyTeamDefensiveLockdown",
  ],
  basketball: [
    "basketballPoints",
    "basketballAssists",
    "basketballRebounds",
    "basketballThreePointers",
    "basketballSteals",
    "basketballTeamWin",
    "basketballTeamThreePointers",
    "basketballTeamOpponentTurnovers",
    "basketballTeamBlocks",
    "basketballTeamOpponentUnderHundredPoints",
  ],
  football: [
    "footballPassingTouchdowns",
    "footballPassing200Yards",
    "footballPassing300Yards",
    "footballPassing350Yards",
    "footballRushingTouchdowns",
    "footballRushing40Yards",
    "footballRushing70Yards",
    "footballRushing100Yards",
    "footballReceivingTouchdowns",
    "footballReceiving50Yards",
    "footballReceiving100Yards",
    "footballReceptions",
    "footballInterceptionsThrown",
    "footballFumblesLost",
    "footballTeamWin",
    "footballTeamLoss",
    "footballTeamFieldGoals40to49",
    "footballTeamFieldGoals50Plus",
    "footballTeamSacks",
    "footballTeamInterceptions",
    "footballTeamDefensiveTouchdowns",
    "footballTeamZeroPointsAllowed",
    "footballTeam1to13PointsAllowed",
    "footballTeam14to28PointsAllowed",
    "footballTeam29PlusPointsAllowed",
  ],
  cricket: [
    "cricketRuns",
    "cricketFours",
    "cricketSixes",
    "cricketFiftyRuns",
    "cricketWickets",
    "cricketThreeWickets",
    "cricketTeamWin",
    "cricketTeamRuns",
    "cricketTeamWickets",
    "cricketTeamSixes",
    "cricketTeamDefensiveLockdown",
  ]
};

export const getScoringBreakdownConfig = (sport) =>
  SCORING_BREAKDOWN_CONFIG_BY_SPORT[sport];
